<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
  import {computed, ref, onBeforeMount} from 'vue';
  import {getComponentConfig} from '@core/utils/getComponentConfig';
  import Icon from '@core/components/Icon.vue';

  interface Props {
    icon?: string;
    class?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    icon: undefined,
    class: '',
  });

  interface CardTitleConfig {
    title: {base: string};
  }

  const defaultConfig: CardTitleConfig = {
    title: {
      base: 'card-title flex items-center px-6 pt-6 pb-2 last:pb-6 text-xl font-bold text-gray-900 dark:text-white',
    },
  };

  const config = ref<CardTitleConfig>(defaultConfig);

  onBeforeMount(async () => {
    config.value = await getComponentConfig('Card', defaultConfig);
  });

  const titleClasses = computed(() => {
    return ['card__title', config.value.title.base, props.class]
      .filter(Boolean)
      .join(' ');
  });
</script>

<template>
  <div :class="titleClasses">
    <Icon
      v-if="icon"
      :name="icon"
      class="me-3 text-brand-primary"
      :size="24" />
    <slot />
  </div>
</template>
